<template>
  <router-link
    :class="tile.selectors.class.link"
    :id="tile.selectors.id.link"
    :to="{ name: tile.properties.link }"
  >
    <img
      :class="tile.selectors.class.img + ' no-select'"
      :id="tile.selectors.id.img"
      :src="imageSrc"
      :alt="tile.properties.imgAlt"
    />
    <div :class="tile.selectors.class.text" :id="tile.selectors.id.text">
      {{ tile.properties.text }}
    </div>
  </router-link>
</template>

<script>

export default {
  name: "SelectionTile",
  props: {
    tile: {
      properties: Object,
      selectors: {
        class: Object,
        id: Object,
      },
    },
  },
  data() {
    return {
      imageSrc: "",
    };
  },
  methods: {},
  created() {
    if (this.tile.properties.imgSrc === undefined) {
      throw(
        `${this.tile.properties.text} image path property is undefined.`
      );
    } else if (this.tile.properties.imgSrc === "") {
      throw(
        `${this.tile.properties.text} image path property has empty value.`
      );
    }
    this.imageSrc = this.$Functions.getImage(this.tile.properties.imgSrc);
  },
  updated() {
    if (this.tile.properties.imgSrc === undefined) {
      throw(
        `${this.tile.properties.text} image path property is undefined.`
      );
    } else if (this.tile.properties.imgSrc === "") {
      throw(
        `${this.tile.properties.text} image path property has empty value.`
      );
    }
    this.imageSrc = this.$Functions.getImage(this.tile.properties.imgSrc);
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.no-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
</style>
